import { useHistory } from 'react-router';
import { useTheme } from 'styled-components';

import { StyledHr } from './Styled';
import WarningPanel from './WarningPanel';

interface SmartTariffWarningProps {
  bodyText?: string;
  linkText?: string;
  linkAction?: () => void;
  styleOverride?: React.CSSProperties;
}

const SmartTariffWarning = ({ bodyText, linkText, linkAction, styleOverride }: SmartTariffWarningProps) => {
  const theme = useTheme();
  const history = useHistory();

  const defaultBodyText = `You need to change to a smart tariff to use ${theme.language.appName}. Open the tariff recommender to find the best smart tariff for you.`;
  return (
    <>
      <WarningPanel
        title="You're not on a smart tariff."
        body={bodyText || defaultBodyText}
        linkText={linkText}
        linkAction={linkAction}
        styleOverride={styleOverride}
      >
        <>
          <StyledHr />
          <div>
            Already switched to a smart tariff?{' '}
            <a className="btn-link" onClick={() => history.push(`/edit/tariff?next=${location.pathname}`)}>
              Add your smart tariff details.
            </a>
          </div>
        </>
      </WarningPanel>
    </>
  );
};

export default SmartTariffWarning;
